<mat-sidenav-container  [hasBackdrop]="false">
  <mat-sidenav-content>
    <div class="container-fluid h-100">
      <div class="row h-100">
        <div class="loader-overlay" [class.shown]="isLoading">
          <fa-icon
            [icon]="icons.falSpinnerThird"
            size="3x"
            animation="spin"
          ></fa-icon>
        </div>
        <div class="col-lg-9 col-md-12 chart">
          <div class="row position-relative flex-column">
            <div
              class="map-container"
              [class.loading]="isLoading"
              id="ftth-detail"
            >
              @if (olMapService.details?.length > 0 || olMapService.detailsLoading) {
<div
                class="details-container"
               
                role="contentinfo"
              >
                <button class="close" (click)="olMapService.details.length = 0"
                aria-label="Close detail bar">
                  <fa-icon [icon]="icons.falTimes"></fa-icon></button
                ><br />
                @if (olMapService.details) {
<ul>
                  @for (detail of olMapService.details; track detail) {
<li>
                    <span class="label">{{
                      detail.label | label | async
                    }}</span>
                    @if (detail.value != null) {
<span class="value">{{
                      detail.value
                    }}</span>
}
                    @if (detail.ratio != null) {
<span class="value"
                      >{{
                        detail.ratio | multiply : 100 | number : "1.0-2"
                      }}%</span
                    >
}
                  </li>
}
                </ul>
}
                @if (olMapService.detailsLoading) {
<fa-icon
                 
                  class="details-loader"
                  [icon]="icons.falSpinnerThird"
                  size="2x"
                  animation="spin"
                ></fa-icon>
}
              </div>
}
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

